

module.exports = __webpack_require__.stylable.create(
    "SectionTitle3760108078",
    {"classes":{"root":"SectionTitle3760108078__root","title":"SectionTitle3760108078__title"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "SectionTitle3760108078",
    null
);
